export const OS_TYPES = {
    ANDROID: "android",
    IOS: "ios",
    MACOS: "macos",
    OTHER: "other",
};

export const getMobileOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return OS_TYPES.ANDROID;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return OS_TYPES.IOS;
    }
    if (/Macintosh|Mac OS X/i.test(userAgent)) {
        return OS_TYPES.MACOS;
    }
    return OS_TYPES.OTHER;
};
